export default __webpack_public_path__ + "Record_Detail.html";